/**
 * The API sends money as integer minor units (LKR cents) so that percentage
 * discounts never drift. The browser's only job is to render them.
 */

const formatter = new Intl.NumberFormat('en-LK', {
  style: 'currency',
  currency: 'LKR',
  currencyDisplay: 'code',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const formatterWithCents = new Intl.NumberFormat('en-LK', {
  style: 'currency',
  currency: 'LKR',
  currencyDisplay: 'code',
  minimumFractionDigits: 2,
});

/**
 * `formatMoney(145000)` -> "LKR 1,450"
 * `formatMoney(145050)` -> "LKR 1,450.50"
 * Whole rupee amounts drop the decimals, because prices on a shelf label do.
 */
export function formatMoney(minor) {
  const value = Number(minor ?? 0);
  const isWhole = value % 100 === 0;
  return (isWhole ? formatter : formatterWithCents).format(value / 100);
}

/** Just the digits, for use next to a separate currency label. */
export function formatAmount(minor) {
  const value = Number(minor ?? 0);
  return new Intl.NumberFormat('en-LK', {
    minimumFractionDigits: value % 100 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(value / 100);
}

/**
 * Minor units back to a plain rupee string for a number input — no separators,
 * no currency, no trailing `.00`. The admin forms are the only place this is
 * needed: prices are submitted in rupees and stored in minor units, so an edit
 * form has to undo the conversion the API did on the way in.
 */
export function rupeesFromMinor(minor) {
  if (minor === null || minor === undefined || minor === '') return '';
  const value = Number(minor) / 100;
  return Number.isInteger(value) ? String(value) : value.toFixed(2);
}
